// @ts-strict-ignore
import { Component, ContentChild, EventEmitter, Input, Output, TemplateRef, ViewEncapsulation } from '@angular/core';
import { uniqueId } from 'lodash-es';
import { InputBaseComponent } from '../input-base/input-base.component';

@Component({
    selector: 'ui-input-checkbox',
    templateUrl: './input-checkbox.component.html',
    styleUrls: ['./input-checkbox.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class InputCheckboxComponent extends InputBaseComponent<boolean> {
  @Input() aria?: { controls?: string };
  @Input() dataCy?: string;
  @Input() name: string = uniqueId('checkbox');
  @Input() tabindex: number;

  @Output() blurEvent: EventEmitter<boolean> = new EventEmitter();
  @Output() focusEvent: EventEmitter<boolean> = new EventEmitter();

  @ContentChild(TemplateRef) optionTemplate;

  private _emit() {
    this.onChange(!this.value);
    this.onTouched();
  }

  onValueChange() {
    this._emit();
  }

  stopEventBubbling(event: Event) {
    event.stopPropagation();
  }

  writeValue(value: any) {
    this.value = value;
  }
}
